export default {
  methods: {
    setType(value) {
      let status = value ? value.toLowerCase() : "";
      if (status.includes("pending")) {
        status = "pending";
      } else if (status.includes("success")) {
        status = "success";
      } else if (status.includes("failed")) {
        status = "failed";
      }

      const warning = ["pending", "incomplete", "verified"];
      const success = ["active", "success"];
      const danger = ["failed", "unverified"];

      if (warning.includes(status)) {
        return "warning";
      } else if (success.includes(status)) {
        return "success";
      } else if (danger.includes(status)) {
        return "danger";
      } else {
        return "info";
      }
    }
  }
};
